import { Badge } from 'slab'

interface PaymentMethodBadgeProps {
  paymentMethod: string
}

export const PaymentMethodBadge = ({ paymentMethod }: PaymentMethodBadgeProps) => {
  const paymentMethodConfig = {
    unit_card: { label: 'Unit Card', type: 'success' as const },
    unit_received_ach: { label: 'Unit Received ACH', type: 'info' as const },
    unit_reimbursement: { label: 'Reimbursement', type: 'caution' as const },
    stripe_card: { label: 'Stripe Card', type: 'info' as const },
    unknown: { label: 'Unknown', type: 'warning' as const },
  }

  if (!paymentMethod) {
    return <Badge type='warning'>Unknown</Badge>
  }

  const config = paymentMethodConfig[paymentMethod as keyof typeof paymentMethodConfig] || paymentMethodConfig.unknown

  return (
    <Badge type={config.type}>
      {config.label}
    </Badge>
  )
}
